import { ValidationComposite } from 'common/presentation/validation/validators';
import { ValidationBuilder } from 'common/presentation/validation/validators/builder/validation-builder';

export const makeLoginValidation = (): ValidationComposite => ValidationComposite.build([
	...ValidationBuilder.field('email' as keyof object).required().email().build(),
	...ValidationBuilder.field('phone' as keyof object).required().build(),
	...ValidationBuilder.field('message' as keyof object).required().build(),
	...ValidationBuilder.field('name' as keyof object).required().build(),
]);
